import React from "react";
import { Box } from "@mui/material";
import { makeStyles } from "tss-react/mui";
import "./EditProvider.js";
import { withEditButton } from "./EditButtonHoc.js";
import "./EditableText.js";
import "./EditableSelect.js";
import "uuid";
const useClasses = makeStyles()(() => ({
  editableAutocompleteInfo: {
    overflow: "hidden",
    textOverflow: "ellipsis",
    width: "100%"
  }
}));
const withEditableAutocomplete = (WrappedComponent) => withEditButton(({ disabled, mode, ...props }) => {
  const { classes } = useClasses();
  const isEditDisabled = disabled || mode !== "Edit" && mode !== "EditMultiStep";
  return /* @__PURE__ */ React.createElement(Box, { className: classes.editableAutocompleteInfo }, /* @__PURE__ */ React.createElement(WrappedComponent, { ...props, mode, isDisabled: isEditDisabled }));
});
export {
  useClasses,
  withEditableAutocomplete
};
//# sourceMappingURL=EditableAutocomplete.js.map
